import React from "react";
import Teachers from "../../components/NewUi/horizontalAnimation/Teachers";
import Heading from "../../components/NewUi/heading/Heading";
import Container from "../../components/ui/Container";
import OffsetButton from "../../components/ui/Buttons/OffsetButton";
import auth from "../../services/authServices";
import Pattern from "../../assets/telawah-assets/patternIslamic.svg";
import { useLanguage } from "../../context/LanguageContext";
import { ReactComponent as QuranIcon } from "../../assets/telawah-assets/quranIconBtn.svg";

const TeacherSection = () => {
    const token = auth.getToken();
    const { language } = useLanguage();

    const content = {
        heading: {
            en: "Religious Scholars",
            ar: "مدرسين وعلماء الدين",
        },
        subtitle: {
            en: "Meet the best teachers ..?",
            ar: "شوف أفضل المدرسين ..؟",
        },
        description: {
            en: "We connect you with the best teachers and religious scholars online, ready to help you understand and learn the Quran and Islamic teachings in a clear and simplified way.",
            ar: "وصلناك لأفضل مدرسين وعلماء الدين أونلاين، مستعدين يساعدوك في تعليم وفهم القرآن الكريم وتعاليم الإسلام بطريقة واضحة ومبسطة.",
        },
        button: {
            en: "Benefit from them now",
            ar: "استفد منهم الآن",
        },
    };

    return (
        <section
            className={`${
                language === "en" ? "en" : "ar"
            } min-h-[80vh] rounded-md mx-2 md:mx-10 relative my-10 overflow-hidden`}
        >
            <Container className="h-full z-10 pt-32 md:pt-10 pb-10 md:pb-0 flex flex-col items-center justify-center space-y-5">
                {/* Header Section */}
                <div className="flex relative flex-col items-center justify-center space-y-5">
                    <div className="flex flex-col items-center justify-center h-fit gap-10">
                        <div className="mx-auto">
                            <Heading
                                title={content.heading[language]}
                                subtitle={content.subtitle[language]}
                            />
                        </div>
                        <p className="text-center text-gray-500 w-full text-lg md:text-xl md:max-w-[600px]">
                            {content.description[language]}
                        </p>
                    </div>
                    {/* CTA Button */}
                    <OffsetButton
                        color="earthYellow"
                        element="Link"
                        ButtonType="Retro"
                        className="scale gap-4 text-earthYellow-950 font-w-bold"
                        to={!token ? "/register" : "/me/user/courses"}
                    >
                        <QuranIcon className=" w-7 h-full " />

                        <span>{content.button[language]}</span>
                    </OffsetButton>
                </div>

                {/* Teachers Animation Section */}
                <div className="relative bg-gray-50 dark:bg-gray-800 smooth">
                    <div
                        className="inset-0 w-full h-full z-0 absolute opacity-40 smooth"
                        style={{
                            backgroundImage: "url(" + Pattern + ")",
                            backgroundSize: "contain",
                            backgroundPosition: "center top",
                            backgroundRepeat: "repeat",
                        }}
                    ></div>
                    <Teachers />
                </div>
            </Container>
        </section>
    );
};

export default TeacherSection;
